// extracted by mini-css-extract-plugin
export default {"section-container":"LineChartSection_section-container__xvdO9"};